<template>
  <div class="timezone-select-field">
    <v-select
      :value="value"
      :items="timezones"
      :label="label"
      item-text="title"
      item-value="value"
      outlined
      required
      :loading="loading"
      :disabled="loading || disabled"
      @change="emitInput"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'TimezoneSelectField',
    props: {
      value: {
        type: String,
        default: null,
      },
      label: {
        type: String,
        default: 'Часовой пояс',
      },
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {
      ...mapGetters({
        timezones: 'app/getTimezones',
      }),
    },
    methods: {
      emitInput (value) {
        this.$emit('input', value)
      },
    },
  }
</script>

<style scoped>

</style>
